import { Component } from '@angular/core';
import { OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertsService } from '../../../services/alerts.service';
import { UserService } from '../../../services/user.service';
import { ReferralService } from '../../services/referral.service';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

/**
 * Component for creating workflow referrals.
 */
@Component({
  selector: 'workflow-referral-add',
  templateUrl: './referral-add.component.html',
  styleUrl: './referral-add.component.css'
})
export class ReferralAddComponent implements OnInit {
	@Input() taskid: any;

	LOCALIZATION: any;

	referTo!: string;
	dueDate!: Date;
	reason!: string;
	inprogress: boolean = false;

	constructor(
		private modalService: NgbActiveModal,
		private alertsService: AlertsService,
		private referralService: ReferralService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;
	}
	
	/**
	 * Creates a referral for the task.
	 */
	referTask(): void {
		this.inprogress = true;
		
		// Date format from HTML <input> type="date" implementation
		let referralDueDate = null;
		if (this.dueDate) {
			referralDueDate = dayjs(this.dueDate, "YYYY-MM-DD").valueOf();
		}		

		let payload = {
			taskId: this.taskid,
			referTo: this.referTo,
			dueDate: referralDueDate,
			reason: this.reason
		};

		this.referralService.addReferral(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.taskReferSuccess,
					delay: 5000
				});
				this.close();
			},
			(err: any) => {
				console.error("Failed to create referral", err);
				this.alertsService.error({
					message: this.LOCALIZATION.taskReferError
				});
				this.inprogress = false;
			}
		);
	}	

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.modalService.dismiss();
	}
}
